import { render, staticRenderFns } from "./FertilizationDetails.vue?vue&type=template&id=1b582e28&scoped=true&"
import script from "./FertilizationDetails.vue?vue&type=script&lang=js&"
export * from "./FertilizationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b582e28",
  null
  
)

export default component.exports